import { ALL_SUPPORTED_CHAINS } from "../constants/chain";
import { RUNTIME_ENV } from "../constants/env";
export var useNetworkOptions = function useNetworkOptions() {
  var networks = ALL_SUPPORTED_CHAINS;
  return networks.filter(function (chain) {
    return chain.matchedEnv.includes(RUNTIME_ENV);
  });
};